import { IMappedProductTreeItem } from '../models/mappedProductTreeItem'
import { IProductTreeItem } from '../models/productTreeItem'

export const mapProductTreeItem = (productTreeItem: IProductTreeItem): IMappedProductTreeItem => {
  return {
    itemId: productTreeItem.Id,
    parentId: productTreeItem.ParentId,
    name: productTreeItem.Name,
    order: productTreeItem.Order,
  }
}
